export const subtractVector = (p, deltaVector) => ({
    x: p.x - deltaVector.x,
    y: p.y - deltaVector.y,
});
